import { Box } from "@bca/ui-library";
import { useCurrentBids } from "../vehicle-search-details/useCurrentBids.hook";
import { ViewportSizeType } from "../hooks/useViewport.hook";
import DesktopSkeletonCard from "../../src/loading-skeleton/DesktopSkeletonCard";
import MobileSkeletonCard from "../../src/loading-skeleton/MobileSkeletonCard";
import TabletSkeletonCard from "../../src/loading-skeleton/TabletSkeletonCard";
import VehicleResultCard from "../vehicle-result-card/VehicleResultCard";
import ZeroResults from "../ZeroResults";
import BackToTopButtonMechanism from "./BackToTopButtonMechanism";
import { useInView } from "react-intersection-observer";
import { useEffect, useState } from "react";
import { Items } from "../vehicle-search-details/vehicleSearch.type";

const CardsContainer: React.FunctionComponent<{
  loading: boolean;
  searchResults: any;
  allQueryStrings: any;
  userType: string;
  viewportWidth: ViewportSizeType;
  selectedVehicles: string[];
  setSelectedVehicles: React.Dispatch<React.SetStateAction<any[]>>;
  currentBidsUrl: string;
  showFilters: boolean;
}> = ({
  loading = true,
  searchResults,
  allQueryStrings,
  userType,
  viewportWidth,
  selectedVehicles,
  setSelectedVehicles,
  currentBidsUrl,
  showFilters,
}) => {
  const { currentBids } = useCurrentBids(currentBidsUrl);
  // Observe card position to display the back to top button
  const [cardScrollPosition, setCardScrollPosition] = useState<
    Number | undefined
  >(3000);
  const [ref, entry] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    entry && setCardScrollPosition(window.pageYOffset);
  }, [entry]);

  if (loading) {
    return (
      <Box
        width="100%"
        display="grid"
        flexDirection="column"
        css={`
          gap: 20px;
        `}
      >
        {viewportWidth === "mobile" && (
          <>
            <MobileSkeletonCard />
            <MobileSkeletonCard />
            <MobileSkeletonCard />
            <MobileSkeletonCard />
          </>
        )}

        {viewportWidth === "tablet" && (
          <>
            <TabletSkeletonCard />
            <TabletSkeletonCard />
            <TabletSkeletonCard />
            <TabletSkeletonCard />
          </>
        )}

        {(viewportWidth === "desktop" || viewportWidth === "smallDesktop") && (
          <>
            <DesktopSkeletonCard />
            <DesktopSkeletonCard />
            <DesktopSkeletonCard />
            <DesktopSkeletonCard />
          </>
        )}
      </Box>
    );
  }

  return (
    <Box
      width="100%"
      display="grid"
      flexDirection="column"
      css={`
        gap: 20px;
      `}
    >
      {searchResults?.totalResults === 0 && Boolean(allQueryStrings?.bq) && (
        <ZeroResults title={`No vehicles found`} />
      )}
      {searchResults?.totalResults === 0 &&
        Boolean(allQueryStrings?.q) &&
        !allQueryStrings?.bq && (
          <ZeroResults
            title={`Your search for “${allQueryStrings.q}” did not match any vehicles`}
          />
        )}
      {searchResults?.totalResults > 0 && (
        <BackToTopButtonMechanism
          cardPosition={cardScrollPosition}
          selectedVehicles={selectedVehicles}
          viewportWidth={viewportWidth}
        />
      )}
      {searchResults?.totalResults > 0 &&
        searchResults.items.slice(0, 50).map((item: Items, index: number) => {
          if (index === 7) {
            return (
              <div ref={ref} key={index}>
                <VehicleResultCard
                  vehicleInfo={item}
                  key={item.vrm}
                  userType={userType}
                  viewportWidth={viewportWidth}
                  selectedVehicles={selectedVehicles}
                  setSelectedVehicles={setSelectedVehicles}
                  currentBids={currentBids}
                  showFilters={showFilters}
                  pdfEnabled={searchResults?.displayFlags?.buyerApiPDFsEnabled}
                />
              </div>
            );
          } else {
            return (
              <VehicleResultCard
                vehicleInfo={item}
                key={item.vrm}
                userType={userType}
                viewportWidth={viewportWidth}
                selectedVehicles={selectedVehicles}
                setSelectedVehicles={setSelectedVehicles}
                currentBids={currentBids}
                showFilters={showFilters}
                pdfEnabled={searchResults?.displayFlags?.buyerApiPDFsEnabled}
              />
            );
          }
        })}
    </Box>
  );
};

export default CardsContainer;
